import { render } from "./ModelViewer.vue?vue&type=template&id=1e5fc6d2&scoped=true"
import script from "./ModelViewer.vue?vue&type=script&lang=js"
export * from "./ModelViewer.vue?vue&type=script&lang=js"

import "./ModelViewer.vue?vue&type=style&index=0&id=1e5fc6d2&scoped=true&lang=css"
import "./ModelViewer.vue?vue&type=style&index=1&id=1e5fc6d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5fc6d2"]])

export default __exports__